import React from 'react';

import { ClientFormOptionGroups } from '~constants/maps';

import { Modal } from '~components';
import { Form as WizardForm } from '~components/wizard-form';

import steps from '~support-at-home/forms/claims/new';

import { useGetClientFormOptionsQuery } from '~lookups/actions/clientFormOptions';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: (toggle: boolean) => void;
}

const ClaimsWizard: React.FC<ComponentProps> = ({ isOpen, setIsOpen }) => {
  // RTK Trigger for NAPS_ID lookup
  useGetClientFormOptionsQuery({ group_reference: ClientFormOptionGroups.NAPS_ID });

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="New Claim"
      headerClassName="header"
      className="claims-wizard-modal"
      includeFooter={false}
      unmountOnClose
    >
      <WizardForm steps={steps} onComplete={() => setIsOpen(false)} submitCaption="Close" />
    </Modal>
  );
};

export default ClaimsWizard;
